/**
 * Sistema de notificaciones tipo toast.
 * Uso:
 *   toast("Mensaje de error")           → rojo (error por defecto)
 *   toast("Guardado", "exito")          → verde
 *   toast("Cargando...", "info")        → azul
 */

function obtenerContenedor() {
  let contenedor = document.getElementById("toast-container");
  if (!contenedor) {
    contenedor = document.createElement("div");
    contenedor.id = "toast-container";
    document.body.appendChild(contenedor);
  }
  return contenedor;
}

export default function toast(mensaje, tipo = "error", duracion = 4000) {
  const contenedor = obtenerContenedor();

  const el = document.createElement("div");
  el.className = `toast toast-${tipo}`;
  el.textContent = mensaje;
  contenedor.appendChild(el);

  // Forzar reflow para que la animación de entrada funcione
  // eslint-disable-next-line no-unused-expressions
  el.offsetHeight;
  el.classList.add("toast-visible");

  setTimeout(() => {
    el.classList.remove("toast-visible");
    el.addEventListener("transitionend", () => el.remove(), { once: true });
  }, duracion);
}
